<template>
  <el-pagination
    class="base-pagination"
    v-bind="$attrs"
    v-on="$listeners"
    @size-change="currentChange"
    @current-change="currentChange"
    @next-click="currentChange"
    @prev-click="currentChange"
  />
</template>
<script>
export default {
  methods: {
    currentChange (e) {
      this.$emit('pagination', e)
    },
  },
}
</script>

<style lang="less">
.base-pagination {
  padding: 15px 15px;
  background: #fff;
  text-align: center;
  border-radius: 0 0 10px 10px;
  /deep/.el-pager {
    li.number {
      border: 1px solid #e2e2e2;
      color: #999;
      border-radius: 8px;
      line-height: 25px;
      margin-left: 8px;
      height: 28px;
      width: 30px;
      min-width: 30px;
      padding: 0;
    }
    li.active {
      background: #3a6bd5 !important;
      border: 1px solid #3a6bd5;
      color: #e1e1e1;
    }
  }
}
</style>
